import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { getDefaultImageByType } from 'shared/constants/defaultImages';
import Link from 'shared/components/Link';
import crownUrl from 'shared/assets/images/crown.svg';
// import LeasingButton from 'shared/components/LeasingOnlineBanner/LeasingButton/LeasingButton';
import LeasingButtonWrapper from 'shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper';

import { SpeedIcon, CalendarIcon } from 'shared/components/Icons';
import AdvertLabel from 'shared/components/AdvertLabel/AdvertLabel';
import Thumb from '../Thumb/Thumb';
import s from './SpecialAdvertCars.css';

const IMAGE_WIDTH = 280;

class SpecialAdvertCars extends React.Component {
  static propTypes = {
    cars: PropTypes.arrayOf(PropTypes.shape()),
    itemsInSlide: PropTypes.number,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    cars: [],
    itemsInSlide: 3,
  };

  state = {
    index: 0,
  };

  getMileage = car => {
    const { intl } = this.props;
    const { isNew, mileage } = car;

    if (isNew) {
      return intl.formatMessage({ id: 'Новый' });
    } else if (mileage) {
      return mileage
        .split(' ')
        .map((item, i) => (i !== 0 ? intl.formatMessage({ id: item }) : item))
        .join(' ');
    }

    return null;
  };

  slideCount = () => Math.ceil(this.props.cars.length / this.props.itemsInSlide);

  handlePrevClick = e => {
    e.preventDefault();
    this.setState(({ index }) => ({ index: (index - 1 + this.slideCount()) % this.slideCount() }));
  };

  handleNextClick = e => {
    e.preventDefault();
    this.setState(({ index }) => ({ index: (index + 1) % this.slideCount() }));
  };

  render() {
    const { index } = this.state;
    const { cars, itemsInSlide, intl } = this.props;
    const firstSlideIndex = index * itemsInSlide;

    const currentCars = cars.slice(
      cars.length - firstSlideIndex > itemsInSlide || cars.length < itemsInSlide
        ? firstSlideIndex
        : cars.length - itemsInSlide,
      firstSlideIndex + itemsInSlide,
    );
    const imageStyle = { height: 190 };

    return (
      <div className={s.root}>
        <div className={s.title}>
          <img src={crownUrl} width="26" height="32" alt="" />&nbsp;{' '}
          <FormattedMessage id="Лучшие предложения" />
        </div>
        <div>
          {currentCars.map(car =>
            <Link to={car.link || ''} className={s.car} key={`${car.id}_best_offers`}>
              <Thumb
                key={Math.random()}
                defaultImg={getDefaultImageByType(car.transport)}
                width={IMAGE_WIDTH}
                photos={car.images}
                style={imageStyle}
                className={s.img}
              />
              <div className={s.subInfo}>
                <div className={s.text}>
                  <div className={s.title}>
                    {car.title}
                  </div>
                  <div className={s.info}>
                    <span>
                      <CalendarIcon /> {car.year}
                    </span>
                    <span>
                      <SpeedIcon /> {this.getMileage(car)}
                    </span>
                  </div>
                  {!car.isNegotiablePrice &&
                    <div className={s.priceWrapper}>
                      <LeasingButtonWrapper advert={car.fullData} />
                    </div>}

                  {car.isNegotiablePrice &&
                    <div className={s.contractPrice}>
                      {intl.formatMessage({ id: 'договорная' })}
                    </div>}
                </div>
              </div>
              <AdvertLabel advert={car.fullData} />
            </Link>,
          )}
        </div>

        <div className={s.btns}>
          <button className={`btn ${s.btnPrev}`} onClick={this.handlePrevClick}>
            <i className={`fa fa-angle-left ${s.btnIcon}`} aria-hidden="true" />{' '}
            <FormattedMessage id="Предыдущие" />
          </button>
          <button className={`btn ${s.btnNext}`} onClick={this.handleNextClick}>
            <FormattedMessage id="Следующие" />{' '}
            <i className={`fa fa-angle-right ${s.btnIcon}`} aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(SpecialAdvertCars));



// WEBPACK FOOTER //
// ./src/desktop/components/SpecialAdvertCars/SpecialAdvertCars.js